module.exports = {"500113003":"龙洲湾街道","500113004":"鱼洞街道","500113005":"花溪街道","500113006":"李家沱街道","500113007":"南泉街道","500113008":"一品街道","500113009":"南彭街道","500113010":"惠民街道","500113103":"界石镇","500113107":"安澜镇","500113108":"圣灯山镇","500113109":"木洞镇","500113110":"双河口镇","500113111":"麻柳嘴镇","500113112":"丰盛镇","500113113":"二圣镇","500113114":"东温泉镇","500113115":"姜家镇","500113116":"天星寺镇","500113117":"接龙镇","500113118":"石滩镇","500113119":"石龙镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500113.json
// module id = 2224
// module chunks = 0